var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.955,
    viewBox: "0 0 18 16.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attachments",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71675",
    "data-name": "Group 71675",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31441",
    "data-name": "Path 31441",
    d: "M16.955,16.877a3.576,3.576,0,0,0-5.052,0L3.483,25.3a2.143,2.143,0,1,0,3.031,3.031l6.736-6.736-1.01-1.01L5.5,27.318a.714.714,0,1,1-1.01-1.01l8.42-8.42a2.143,2.143,0,0,1,3.031,3.031l-8.42,8.42a3.572,3.572,0,1,1-5.052-5.052l8.42-8.42-1.01-1.01-8.42,8.42a5,5,0,0,0,7.073,7.073l8.42-8.42A3.576,3.576,0,0,0,16.955,16.877Z",
    transform: "translate(0 -14.856)",
    fill: "#8a8989"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/attachments.7dc1ce256e32fd64a0c16f66da414478.svg";
export { ForwardRef as ReactComponent };